module.exports = {
  text: `Я слышал, из кентавров получаются отличные скакуны!`,
  author: `Бэтли Летноног, полурослик искатель приключений, никода не читавший КОПЫТА ЯРОСТИ Ирвила Грэйборна из Солнечных увалов`,
}
